import type { DiceData } from "@/types";
import { create } from "zustand";
import { persist } from "zustand/middleware";

type UserDiceDataState = {
  [userId: number]: DiceData;
  getUserDiceData: (userId: number) => DiceData | undefined;
  setUserDiceData: (userId: number, diceData: DiceData) => void;
};

export const userDiceDataFns: Pick<
  UserDiceDataState,
  "getUserDiceData" | "setUserDiceData"
> = {
  getUserDiceData: (userId: number): DiceData | undefined =>
    useUserDiceDataStore.getState()[userId],
  setUserDiceData: (userId: number, diceData: DiceData): void => {
    const state = useUserDiceDataStore.getState();

    useUserDiceDataStore.setState({
      ...state,
      [userId]: diceData,
    });
  },
};

export const useUserDiceDataStore = create<UserDiceDataState>()(
  persist(
    () => ({
      ...userDiceDataFns,
    }),
    {
      name: "userDiceData",
    },
  ),
);
